import { api } from "constants/RotasAPI";
import usePost from "hooks/usePost";
import { ConfigAssinanteDocumentoDTO } from "../../types/dto/groupsign/ConfigAssinanteDocumentoDTO";

export const usePostCriarConfigAssinanteDocumento = () => {
  return usePost<ConfigAssinanteDocumentoDTO>({
    url: api.groupsign.configuracaoAssinanteDocumento,
  });
};
